import script from "./MobileFirstPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileFirstPage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileFirstPage.vue?vue&type=style&index=0&id=dfc2ed32&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfc2ed32"]])

export default __exports__